import { FC, ReactElement, useMemo, useState } from 'react'
import styled from 'styled-components'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import SVG, { Props as SVGProps } from 'react-inlinesvg'
import { useSpring, animated } from '@react-spring/web'
// @ts-ignore
import { Scrollama, Step } from 'react-scrollama'

const TimelineModule: FC = (): ReactElement => {
  const [progress, setProgress] = useState(0)
  const [loaded, setLoaded] = useState(false)
  const [container, setContainer] = useState<HTMLDivElement | null>(null)

  const spring = useSpring({
    translateY: progress * 100,
  })

  const handleWaypointEnter = () => {
    console.log('ENTER')
  }

  const handleWaypointLeave = () => {
    console.log('LEAVE')
  }

  const handleOnProgress = (e: any) => {
    // setProgress(e.progress)
  }

  // const animatedIllustrations = useMemo(() => {
  //   return [...Array(20).keys()].map(() => ({
  //     x: Math.random(),
  //     y: Math.random(),
  //     rotation: Math.random(),
  //     speed: Math.random(),
  //   }))
  // }, [])

  return (
    <Container ref={setContainer}>
      {/* {animatedIllustrations.map((v, i) => {
        return (
          <Illustration
            key={i}
            x={v.x * window.innerWidth / 2 - 400}
            y={
              v.y *
              (container
                ? container.getBoundingClientRect().height
                : window.innerHeight)
            }
            style={{
              transform: spring.translateY.to(
                (y) =>
                  `translateY(${-y * v.speed * 10}px) rotate(${
                    v.rotation * 360
                  }deg)`
              ),
            }}
            src={require('./depakine.png')}
            alt='Tablette de Dépakine'
          />
        )
      })} */}

      <Scrollama
        onStepEnter={handleWaypointEnter}
        onStepExit={handleWaypointLeave}
        onStepProgress={handleOnProgress}
        offset={0.5}
      >
        <Step data={1}>
          <TimelineContainer>
              <StyledSVG
                onLoad={() => {
                  setLoaded(true)
                }}
                src={require('./timeline.svg').default}
                title='Chronologie'
              />
          </TimelineContainer>
        </Step>
      </Scrollama>
    </Container>
  )
}

const TimelineContainer = styled.div`
  width: 100%;
  max-width: 600px;
`

const Illustration = styled(animated.img)<{ x: number; y: number }>`
  position: absolute;
  left: ${({ x }) => x}px;
  top: ${({ y }) => y}px;
  width: 150px;
  mix-blend-mode: luminosity;
`

const StyledSVG = styled(SVG)<SVGProps>`
  width: 100%;
  height: auto;
  max-width: 600px;
`

const Container = styled.div`
  background-color: #222233;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
`

export default TimelineModule
